// ✅ Trekkin.app — useMapStore.jsx v3.0.0 (Firebase Core)
// 🔹 Gere posição GPS local + sincronização RTDB (serverless)
// 🔹 Atualiza localização do utilizador e lê posições dos outros
// 🔹 Compatível com useAuthStore e firebaseConfig.js v1.1.0
// 🔹 Funciona online/offline com fallback localStorage

import { create } from "zustand";
import { ref, set, onValue, off } from "firebase/database";
import { db, auth } from "../firebaseConfig";

export const useMapStore = create((set, get) => ({
  // 📍 Estado atual do mapa / utilizador
  userLocation: null,     // { lat, lng, accuracy }
  otherUsers: {},         // { uid: { lat, lng, name } }
  watching: false,
  trailId: null,          // ID do trilho ativo
  lastUpdate: null,

  // 🧭 Inicia o GPS + sincronização
  startTracking: () => {
    if (get().watching) return; // evita duplicar watcher
    console.log("📡 Tracking iniciado...");

    const geoSuccess = (pos) => {
      const { latitude: lat, longitude: lng, accuracy } = pos.coords;
      const uid = auth.currentUser?.uid;
      const name = auth.currentUser?.displayName || "Trekker";
      const newLoc = { lat, lng, accuracy, timestamp: Date.now() };

      set({ userLocation: newLoc, lastUpdate: Date.now() });

      // 🔄 Atualiza Firebase RTDB
      if (uid) {
        set(ref(db, `users/${uid}/location`), {
          lat,
          lng,
          accuracy,
          name,
          lastUpdate: Date.now(),
        }).catch((err) => console.warn("⚠️ Firebase update:", err.message));
      }

      // 💾 Guarda localmente (modo offline)
      localStorage.setItem("trekkin_last_location", JSON.stringify(newLoc));
    };

    const geoError = (err) => {
      console.warn("⚠️ GPS erro:", err.message);
    };

    const watchId = navigator.geolocation.watchPosition(geoSuccess, geoError, {
      enableHighAccuracy: true,
      maximumAge: 5000,
      timeout: 10000,
    });

    set({ watching: true });
    // Armazena ID para parar mais tarde
    get()._geoWatchId = watchId;
  },

  // 🛑 Para o tracking GPS
  stopTracking: () => {
    const id = get()._geoWatchId;
    if (id) navigator.geolocation.clearWatch(id);
    set({ watching: false });
    console.log("🛑 Tracking parado.");
  },

  // 🔁 Lê todos os utilizadores no RTDB
  subscribeUsers: () => {
    console.log("👀 A escutar posições de outros utilizadores...");
    const usersRef = ref(db, "users");

    onValue(usersRef, (snapshot) => {
      const data = snapshot.val() || {};
      const uid = auth.currentUser?.uid;
      // Remove a própria posição
      delete data[uid];
      set({ otherUsers: data });
    });

    get()._unsubscribe = () => off(usersRef);
  },

  // 🚪 Cancela listener
  unsubscribeUsers: () => {
    if (get()._unsubscribe) get()._unsubscribe();
    set({ otherUsers: {} });
    console.log("👋 Listener de utilizadores removido.");
  },

  // 💾 Restaura última posição local (offline)
  restoreLastLocation: () => {
    try {
      const raw = localStorage.getItem("trekkin_last_location");
      if (!raw) return;
      const loc = JSON.parse(raw);
      set({ userLocation: loc });
      console.log("📍 Localização restaurada:", loc);
    } catch (err) {
      console.warn("⚠️ Erro ao restaurar última posição:", err);
    }
  },

  // 🗺️ Define o trilho ativo
  setTrail: (trailId) => {
    set({ trailId });
    console.log("🧭 Trilho ativo:", trailId);
  },
}));